var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yandex--map",staticStyle:{"position":"relative","overflow":"hidden"}},[_c('iframe',{staticStyle:{"position":"relative"},attrs:{"src":"https://yandex.ru/map-widget/v1/-/CCUia0SkkB","frameborder":"1","allowfullscreen":"true"}})])
}]

export { render, staticRenderFns }